// @core/api/endpoints/authn/reset_password.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ResetPasswordRequest,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Reset password with token
 * Completes the password reset process using a valid reset token. Sets the new password and invalidates all existing sessions for security.
 * @public This endpoint does not require authentication
 */
export async function ResetPassword(
  data: ResetPasswordRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/auth/password/reset`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<Response>(requestPath, data, requestOptions);
}
